module.exports = __webpack_public_path__ + "static/media/lock.1c126a7d.svg";